import { useEffect } from "react";

import { useAuth } from "@hooks/useAuth";

import { PageLoader } from "./PageLoader";

export const SigningOut = () => {
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return <PageLoader message="Signing out" />;
};
